import React from 'react'
import Navbar from '../components/Navbar'
import bg1 from '../assets/bg-pozyczkiunijne.jpg'
import Footer from '../components/Footer'

function PozyczkiUnijne() {
  return (
    <div>
    <Navbar />
    <div className='pt-20 flex justify-center mx-auto static'>
        <div className='bg-white bg-opacity-90 absolute mx-auto justify-center mt-32 max-w-[450px] text-center py-2 rounded-xl px-2'>
          <h3 className='uppercase text-xl md:text-3xl font-semibold pb-2'>Pożyczki/ dofinansowania unijne</h3>
        </div>
      <img src={bg1} alt="background photo" className='w-screen h-96 object-cover'/>
    </div>
    
    <div className='max-w-[1240px] bg-white mx-auto justify-center text-center'>
        <div className='pt-16'>
          <h3 className='text-xl md:text-3xl font-bold'>Dofinansowanie unijne</h3>
          <p className='px-20 pt-4'>Wraz z Naszymi partnerami pomagamy w obsłudze dofinansowania/dotacji na każdym etapie realizacji projektu. Pomożemy w opracowaniu i przygotowaniu wniosków i wszelkich dokumentów związanych z pozyskaniem dofinansowania lub kredytu na rozwój firmy oraz przeprowadzimy przez cały proces projektu aż po jego rozliczenie. Dofinansowanie dla firm rozliczymy zgodnie z obowiązującymi przepisami, ze szczególnym uwzględnieniem specyfiki prowadzonej działalności gospodarczej.</p>
        </div>
        <div className='pt-16'>
          <h3 className='text-xl md:text-3xl font-bold'>Kredyt ze wspraciem unijnym</h3>
          <p className='px-20 pt-4'>Priorytetem jest wspieranie rozwoju mikro, małychi średnich przedsiębiorstw oraz przedsięwzięć mających na celu rozwój województwa. Poprzez ułatwianie dostępu do finansowania dłużnego, w drodze udzielania pożyczek m.in. na cele związane z podejmowaniem i prowadzeniem działalności gospodarczej, a także wspieranie wszelkich przedsięwzięć i inicjatyw służących rozwojowi przedsiębiorczości, w tym również  w dziedzinie ekonomii społecznej. Oferowane za naszym pośrednictwem pożyczki finansowane są ze środków samorządowych oraz Unii Europejskiej. Przygotowujemy klientowy analizy finansowe oraz biznesplan, które są niezbędne do uzyskania finansowania.</p>
        </div>
    <Footer />
    </div>  
    </div>
  )
}

export default PozyczkiUnijne